import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-datos',
  templateUrl: './base-datos.component.html',
  styleUrls: ['./base-datos.component.scss']
})
export class BaseDatosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
